import { useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import ChevronLeft from 'components/icons/chevronLeft';
import LockClosedIcon from 'components/icons/lockClosed';
import ChatIcon from 'components/icons/chat';
import useNavigateWithQuery from 'hooks/useNavigateWithQuery';
import BasicPageLayout from 'layouts/BasicPage';
import { RenderIf } from 'react-rainbow-components';
import MenuItem from './menuItem';
import {
    Container,
    Content,
    Divider,
    Header,
    HeaderLeft,
    Info,
    StyledButtonIcon,
    StyledCard,
    CardTitle,
    CardSubtitle,
    LeftColumn,
    Options,
    RightColumn,
} from './styled';

const ConversationsSettingsPage = () => {
    const { agentId = '' } = useParams();
    const [showBackButton, setShowBackButton] = useState<boolean>(false);
    const navigate = useNavigateWithQuery();
    const location = useLocation();

    useEffect(() => {
        const { state } = location;
        setShowBackButton(state?.from === 'threads');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <BasicPageLayout>
            <StyledCard>
                <Container>
                    <Header>
                        <HeaderLeft>
                            <RenderIf isTrue={showBackButton}>
                                <StyledButtonIcon
                                    variant="base"
                                    borderRadius="semi-square"
                                    icon={<ChevronLeft />}
                                    onClick={() => navigate(`/${agentId}/threads`)}
                                />
                            </RenderIf>
                            <Info>
                                <CardTitle>Conversations Settings</CardTitle>
                                <CardSubtitle>
                                    Manage conversation settings and preferences
                                </CardSubtitle>
                            </Info>
                        </HeaderLeft>
                    </Header>
                    <Divider />
                    <Content>
                        <LeftColumn>
                            <Options>
                                <MenuItem
                                    to="api-keys"
                                    label="API Keys & Access"
                                    icon={<LockClosedIcon />}
                                />
                                <MenuItem
                                    to="channel-settings"
                                    label="Channel Settings"
                                    icon={<ChatIcon />}
                                />
                            </Options>
                        </LeftColumn>
                        <RightColumn>
                            <Outlet />
                        </RightColumn>
                    </Content>
                </Container>
            </StyledCard>
        </BasicPageLayout>
    );
};

export default ConversationsSettingsPage;
